export function Logo({ className = "", size = 34 }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg width={size} height={size * 1.16} viewBox="0 0 96 112" fill="none" aria-hidden="true">
        <path
          d="M48 4 L88 20 V54 C88 82 70 100 48 108 C26 100 8 82 8 54 V20 Z"
          stroke="#F0742A"
          strokeWidth="4"
          fill="#0F1115"
        />
        <path
          d="M30 74 C34 40 52 34 68 28 C50 40 46 58 44 80 C40 75 34 74 30 74 Z"
          fill="#F0742A"
        />
      </svg>
      <div className="leading-none">
        <span className="heading text-xl text-white">HARS</span>
        <span className="heading text-xl text-hars-orange">PRO</span>
      </div>
    </div>
  );
}
